// extracted by mini-css-extract-plugin
export default {"loginBtn":"LoginButton_loginBtn__yo5aW","shortLanding":"LoginButton_shortLanding__frdQZ"};